import type { User } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import { YEAR_FIRST_DATE_FORMAT } from '../utils.datetime'
import { USERS_QUERY_KEY, USERS_URL } from './queryConstants'

type UseUsersListProps = {
  selectedDate?: Date
  type?: string
  active?: boolean
  otherFilterParams?: Record<string, any>
}

type UseUsersListReturn = {
  users: User[] | []
  isLoading: boolean
  unassignedHours: number
}

const FIELDS = [
  'id',
  'name',
  'picture',
  'active',
  'deleted',
  'role',
  'email',
  'phoneNumber',
  'workProfile',
  'assignedMinutes'
]
const useUsersList = ({
  selectedDate,
  type,
  active,
  otherFilterParams = {}
}: UseUsersListProps): UseUsersListReturn => {
  const date = dayjs(selectedDate).format(YEAR_FIRST_DATE_FORMAT)

  const params = getQueryParams({
    date,
    type,
    active,
    fields: FIELDS,
    ...otherFilterParams
  })

  const { data, isLoading } = useQuery([USERS_QUERY_KEY, params], () =>
    getJSON({ url: `${USERS_URL}?${params}`, isRota: true })
  )

  const sortedUsers = data?.data
    ? [...data.data].sort((a, b) => {
        const nameA = `${a.name?.first} ${a.name?.last}`.toLowerCase()
        const nameB = `${b.name?.first} ${b.name?.last}`.toLowerCase()
        return nameA.localeCompare(nameB)
      })
    : []

  return {
    users: sortedUsers,
    isLoading,
    unassignedHours: data?.metadata?.unassignedHours ?? 0
  }
}

export default useUsersList
